import React from "react";

export default function TestSimple() {
  console.log("TestSimple component rendering!");

  return (
    <div style={{ padding: "20px", backgroundColor: "yellow", margin: "20px" }}>
      <h1>SIMPLE TEST PAGE</h1>
      <p>If you can see this, the routing is working!</p>
      <p>Current time: {new Date().toISOString()}</p>
    </div>
  );
}
